import PageLayout from "@/components/layout/PageLayout";
import TradeContent from "@/routes/_main/trade/-components/TradeContent";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_main/trade")({
  component: RouteComponent,
});

function RouteComponent() {
  console.log("TradeIndex");
  return (
    <PageLayout>
      <TradeContent>
        <Outlet />
      </TradeContent>
    </PageLayout>
  );
}
